import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { GameProvider } from './contexts/GameContext';
import { OnlineStatusProvider } from './contexts/OnlineStatusContext';
import { RemoteKeyboardProvider } from './components/feature/RemoteKeyboardProvider';
import RemoteKeyboardOverlay from './components/feature/RemoteKeyboardOverlay';
import { AppRoutes } from './router';
import PasswordChangeAlert from './components/feature/PasswordChangeAlert';
import MaintenanceCheck from './components/feature/MaintenanceCheck';
import CookieConsent from './components/feature/CookieConsent';
import IntroSplash from './components/feature/IntroSplash';
import ScrollToTop from './components/feature/ScrollToTop';
import OfflineStatusBar from './components/feature/OfflineStatusBar';
import StaffRouteGuard from './components/feature/StaffRouteGuard';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <AuthProvider>
        <NotificationProvider>
          <GameProvider>
            <OnlineStatusProvider>
              <RemoteKeyboardProvider>
                <IntroSplash />
                <MaintenanceCheck />
                <PasswordChangeAlert />
                <CookieConsent />
                <OfflineStatusBar />
                <AppRoutes />
                <StaffRouteGuard />
                <RemoteKeyboardOverlay />
              </RemoteKeyboardProvider>
            </OnlineStatusProvider>
          </GameProvider>
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;